<template>
    <div class="border-wrapper dropdown-container"
        v-bind:class="{ 'open' : open }">
        <div class="">
            <div class="border-wrapper__heading dropdown-container__heading"
                 @click.prevent="toggleDropdown()">
                <h2>
                    {{ heading }}
                </h2>

                <a href="#" class="dropdown-container__dropdown-icon">
                    <span class="inline-fa" v-if="open">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"/></svg>
                    </span>

                    <span class="inline-fa" v-else>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"/></svg>
                    </span>

<!--                    <i class="fas fa-times" v-if="open"></i>-->
<!--                    <i class="fas fa-plus" v-else></i>-->
                </a>
            </div>

            <div class="border-wrapper__inner dropdown-container__inner"
                 v-bind:class="{ 'active' : open }">

                <slot></slot>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        name: {
          default: () => ''
        },
        heading: {
            default: () => ''
        },
        open: {
            default: () => false
        }
    },

    data() {
        return {

        }
    },

    methods: {
        toggleDropdown() {
            if (!this.open) this.$emit('open-container');
            else this.$emit('close-container');
        }
    },

    created() {

    },

    mounted() {

    }
}
</script>

<style lang="scss" scoped>
.dropdown-container {
    padding: 0.5rem 1rem 1rem 1rem;

    h2 {
        margin-bottom: 0;
        margin-top: 0.5rem;
    }

    &--purple {
        border-color: $color-purple!important;
    }

    &--purple &__heading {
        color: $color-purple;
    }

    &--purple &__inner {
        border-color: $color-purple!important;
    }

    &--purple &__dropdown-icon {
        color: $color-purple;
    }

    &--purple:hover &__dropdown-icon {
        color: $color-pink!important;
    }

    &__heading {
        cursor: pointer;
        position: relative;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        margin-bottom: 0;
        border-bottom: none;
        padding: 0;
        color: $color-light-blue;
        letter-spacing: 8px;
    }

    &__dropdown-icon {
        position: absolute;
        top: 0.2rem;
        right: 1rem;
        color: $color-white;
        font-size: 16px;
        transition: 0.2s ease-in;

        @include media-breakpoint-up(md) {
            top: 0.5rem;
        }
    }

    &:hover &__dropdown-icon {
        color: $color-gold;
    }

    &.open &__dropdown-icon {
        color: $color-gold;
    }

    &__inner {
        //display: none;
        visibility: hidden;
        overflow: hidden;
        max-height: 0;
        transition: all 0.5s ease-in-out;
        border-top: 1px solid $color-light-blue;

        &.active {
            //display: block;
            visibility: visible;
            padding: 2rem 0 1rem 0;
            max-height: fit-content;
            overflow-y: auto;
            margin-top: 1rem;
        }
    }
}
</style>